import { render, staticRenderFns } from "./archiv_detail.vue?vue&type=template&id=8a10896e&scoped=true&"
import script from "./archiv_detail.vue?vue&type=script&lang=js&"
export * from "./archiv_detail.vue?vue&type=script&lang=js&"
import style0 from "./archiv_detail.vue?vue&type=style&index=0&id=8a10896e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a10896e",
  null
  
)

export default component.exports